import React from 'react';
import NumberInput from './NumberInput';
import { kebabCase } from 'lodash';

interface TitledNumberInputProps {
  title: string;
  subtitle?: string;
  value: number;
  disabled?: boolean;
  setValue: (value: number) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  testId?: string;
  skipTitle?: boolean;
}

export const TitledNumberInput = ({
  title,
  value,
  disabled,
  setValue,
  subtitle,
  onFocus,
  onBlur,
  testId,
  skipTitle,
}: TitledNumberInputProps) => {
  return (
    <div>
      {(title || subtitle) && !skipTitle && (
        <div className="text-[12px] font-bold mr-[5px]">
          {title}
          {subtitle && <span className="font-normal"> {subtitle}</span>}
        </div>
      )}
      <NumberInput
        className="mt-0.5 w-24"
        align="right"
        inputClassName="pr-1"
        disabled={disabled}
        label={`${title}, %`}
        data-testid={testId ?? `qa-${kebabCase(title)}-tax-rate-defaults-input`}
        precision={2}
        step={0.1}
        onChange={(value) => setValue(value / 100)}
        min={0}
        max={100}
        height={35}
        unitSymbol="%"
        value={value * 100}
        controlled
        onFocus={onFocus}
        onBlur={onBlur}
      />
    </div>
  );
};
